import produce from 'immer';
import {
  NOTIFICATION_LIST_FAILURE,
  NOTIFICATION_LIST_REQUEST,
  NOTIFICATION_LIST,
  NOTIFICATION_READ_FAILURE,
  NOTIFICATION_READ_REQUEST,
  NOTIFICATION_READ_SUCCESS, NOTIFICATION_REMOVE_REQUEST, NOTIFICATION_RESPONSE_MESSAGE
} from '../../constants/notification/notificationConstants';

/*
* public class NotificationListData
{
    public long NotificationNo { get; set; }
    public int ManagerNo { get; set; }
    public string Message { get; set; } = string.Empty;
    public string? Link { get; set; }
    public bool Read { get; set; }
    public DateTime CreateAt { get; set; }
}
* */
const initialState = {
  list: null,
  resultCode: null,
  message: null,
};

/* eslint-disable default-case, no-param-reassign */
const notificationReducer = (state = initialState, action = {}) => produce(state, draft => {
  switch (action.type) {
    case NOTIFICATION_LIST_REQUEST:
      break;
    case NOTIFICATION_LIST:
      draft.list = action.list;
      break;
    case NOTIFICATION_LIST_FAILURE:
      break;
    case NOTIFICATION_READ_REQUEST:
      break;
    case NOTIFICATION_READ_SUCCESS:
      draft.resultCode = action.payload.resultCode;
      break;
    case NOTIFICATION_READ_FAILURE:
      break;
    case NOTIFICATION_REMOVE_REQUEST:
      break;
    case NOTIFICATION_RESPONSE_MESSAGE:
      draft.resultCode = action.resultCode;
      draft.message = action.message;
      break;
    default:
      break;
  }
});

export default notificationReducer;
